// structs not used in messages
// ==========

// used internally in RTCClient
export interface VideoChunk {
	data: ArrayBuffer;
	offset: number;
}

// used internally in RTCServer
export interface PeerConnectionData {
	peerConnection: RTCPeerConnection;
	dataChannel: RTCDataChannel;
}

// messages sent from RTCClient to RTCServer
// ==========

export interface WebRTCConnectionRequest {
	sessionId: string;
	//videoPath: string;
}

export interface WebRTCSignalingMessage {
	sessionId: string;

	// comps
	answer?: n|{answer: RTCSessionDescriptionInit};
	candidate?: n|{candidate: RTCIceCandidate};
}

export class DataChannelMessage_ClientToServer {
	constructor(data: DataChannelMessage_ClientToServer) { Object.assign(this, data); }
	videoRequest?: n|VideoRequest;
}
export interface VideoRequest {
	videoPath: string;
	clipStartTime: number;
	clipDuration: number;
	audioTrack_preferredLanguage: string;
}

// messages sent from RTCServer to RTCClient 
// ==========

export interface WebRTCOfferResponse {
	type: "offer";
	offer: RTCSessionDescriptionInit;
	sessionId: string;
}

export interface WebRTCSignalingResponse {
	success: boolean;
	error?: string;
}

export class DataChannelMessage_ServerToClient {
	constructor(data: DataChannelMessage_ServerToClient) { Object.assign(this, data); }
	videoStart?: n|{
		videoPath: string;
		totalSize: number; // total size of clip video-contents, in bytes (not base64-encoded string-size, but bytes after decoding)
	};
	videoChunkInfo?: n|VideoChunkInfo;
	// note: the raw video-chunk data is sent as binary data in the data channel, so has no interface definition
}
export interface VideoChunkInfo {
	videoPath: string;
	offset: number; // offset in bytes (it's sourced from the same ArrayBuffer that totalSize above is sourced from)
	isLast: boolean;
}

// between server's web-frontend and kotlin-backend
// ==========

export interface VideoChunkData {
	data: string; // Base64 encoded
	timeOffset: number; // in seconds
	clipDuration: number; // in seconds
	bytesRead: number;

	// if errored
	error?: string;
}